import { z } from 'zod';
import { getPasswordStrength, PasswordStrength } from '@optimus-web/core';
import { TextKey } from '@mews-framework/localization';
import { passwordRequirements } from '../../utils';
import { CustomErrorParams, CustomErrorType } from '../CustomErrorType';

export const requiredStringSchema = z.string().trim().min(1);
export const emptyStringSchema = z.string().or(z.literal(''));
export const passwordSchema = z
    .string()
    .refine((password) => getPasswordStrength(passwordRequirements, password) === PasswordStrength.Good, {
        params: {
            errorType: CustomErrorType.Other,
            textKey: TextKey.PasswordWeakErrorMessage,
        } satisfies CustomErrorParams,
    });
